const passwordPolicy = {
  minimumLength: 10,
  maximumLength: 16,
  requireLowercase: true,
  requireNumbers: true,
  requireSymbols: true,
  requireUppercase: true,
};

const validateEmail = (
  email: string,
  setEmailError: (value: string) => void
): boolean => {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  if (!emailRegex.test(email)) {
    setEmailError('이메일 형식이 올바르지 않습니다.');
    return false;
  }

  setEmailError('');
  return true;
};

const validatePassword = (
  password: string,
  setPasswordError?: (value: string) => void,
  setPasswordSuccess?: (value: string) => void
): boolean => {
  const passwordSuccessMessage = '설정 가능한 비밀번호 입니다.';

  // password가 없을때는 메세지 모두 초기화
  if (!password) {
    if (setPasswordError) setPasswordError('');
    if (setPasswordSuccess) setPasswordSuccess('');
    return true;
  }

  if (
    password.length < passwordPolicy.minimumLength ||
    password.length > passwordPolicy.maximumLength ||
    (passwordPolicy.requireLowercase && !/[a-z]/.test(password)) ||
    (passwordPolicy.requireUppercase && !/[A-Z]/.test(password)) ||
    (passwordPolicy.requireNumbers && !/[0-9]/.test(password)) ||
    (passwordPolicy.requireSymbols && !/[^a-zA-Z0-9\s]/.test(password))
  ) {
    if (setPasswordError)
      setPasswordError(
        `${passwordPolicy.minimumLength}~${passwordPolicy.maximumLength}자의 영문 대소문자,숫자,특수문자를 포함해야 합니다.`
      );
    return false;
  }

  if (setPasswordSuccess) setPasswordSuccess(passwordSuccessMessage);
  if (setPasswordError) setPasswordError('');
  return true;
};

export { validateEmail, validatePassword };
